module.exports = __webpack_public_path__ + "img/logo-undip.a6a0a2a8.png";